import { BusinessIndustry } from "components/tabs/kyc/businessIndustry/BusinessIndustry";
import { Navigate } from "react-router-dom";
import KycOutlet from "./pages/kyc-outlet";
import KycLists from "./pages/kyc-list";
import KycDetails from "./pages/kyc-details";
import PermissionGuard from "@/guards/permission-guard";
import { CAPABILITIES } from "@/config/permissions";

const KycRoutes = [
  {
    path: "/kyc",
    element: (
      <PermissionGuard capability={CAPABILITIES.KYC_VIEW}>
        <KycOutlet />
      </PermissionGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="business-kyc" replace />,
      },
      {
        path: "business-kyc",
        element: <KycLists />,
      },
      {
        path: "business-kyc/:merchantId",
        element: <KycDetails />,
      },
      {
        path: "business-industry",
        element: <BusinessIndustry />,
      },
    ],
  },
];

export default KycRoutes;
